import { render, staticRenderFns } from "./NovaVenda.vue?vue&type=template&id=a986afe4&scoped=true"
import script from "./NovaVenda.vue?vue&type=script&lang=js"
export * from "./NovaVenda.vue?vue&type=script&lang=js"
import style0 from "./NovaVenda.vue?vue&type=style&index=0&id=a986afe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a986afe4",
  null
  
)

export default component.exports